import styles from "./index.module.scss";
import { FtLoading } from "@/components";
import { useCommonStore } from "@/stores";
import { useTranslation } from "react-i18next";

const GlobalLoading = () => {
  const { t } = useTranslation();

  const globalLoading = useCommonStore(state => state.globalLoading);

  return (
    <div
      style={{
        display: globalLoading ? "block" : "none"
      }}
      className={styles["root"]}
    >
      <div
        className={styles["mask"]}
      ></div>

      <FtLoading
        title={t("global_loading_title")}
      ></FtLoading>
    </div>
  )
}

export default GlobalLoading;